import { useTheme } from "@material-ui/core";
export const useMapStyle = () => {
    const theme = useTheme();
    return theme && theme.palette.type === "dark"
        ? "mapbox://styles/gisfeedback/cjvod9hc909kh1eo9nj23g33k"
        : "mapbox://styles/gisfeedback/cj6yh34pk0ga92slnivcr5v4n";
};
